// extracted by mini-css-extract-plugin
module.exports = {"available":"TutorStatus_available__2mb1f","busy":"TutorStatus_busy__2gIWC","status-dot":"TutorStatus_status-dot__3g8jn"};